import { render, staticRenderFns } from "./VSelect.vue?vue&type=template&id=1991f5b0&scoped=true"
import script from "./VSelect.vue?vue&type=script&lang=js"
export * from "./VSelect.vue?vue&type=script&lang=js"
import style0 from "./VSelect.vue?vue&type=style&index=0&id=1991f5b0&prod&scoped=true&lang=css"
import style1 from "./VSelect.vue?vue&type=style&index=1&id=1991f5b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1991f5b0",
  null
  
)

export default component.exports